import classNames from "classnames";
import { useEffect, useState } from "react";

export function useScrollFadeHorizontal(containerRef: React.RefObject<HTMLDivElement>) {
  const [isLeftFadeVisible, setIsLeftFadeVisible] = useState(false);
  const [isRightFadeVisible, setIsRightFadeVisible] = useState(false);

  useEffect(() => {
    const container = containerRef.current;

    const handleScroll = () => {
      if (!containerRef.current) {
        setTimeout(handleScroll, 50);
        return;
      }

      const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;

      setIsLeftFadeVisible(scrollLeft > 0);
      setIsRightFadeVisible(scrollLeft + clientWidth < scrollWidth);
    };

    handleScroll();
    container?.addEventListener("scroll", handleScroll);

    // Also handle the case when the window is resized
    window.addEventListener("resize", handleScroll);

    return () => {
      container?.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [setIsLeftFadeVisible, setIsRightFadeVisible, containerRef.current]);

  const containerClassNames = classNames("overflow-scroll-wrapper", {
    "right-gradient": isRightFadeVisible,
    "left-gradient": isLeftFadeVisible,
  });

  return {
    containerClassNames,
    isLeftFadeVisible,
    isRightFadeVisible,
  };
}
